/* =========================================================================
   EP Nutrition – Mobile-Menü v3 (App-Stil, Drawer #site-menu-sidebar)
   Datei: assets/ep-mobile-menu-v3.js – 25.10.2026 (defer)
   Markup: snippets/ep-mobile-menu-v3.liquid (alle Unteransichten serverseitig im DOM, hidden).
   - Tabs Kategorien | Marken | Ratgeber (role=tablist/tab/tabpanel, Pfeiltasten).
   - Kachel → Unteransicht schiebt von rechts herein (250 ms; prefers-reduced-motion: sofort),
     Fokus auf „Zurück“; Zurück → Startansicht, Fokus zurück auf die Kachel. Zurück-Taste (Android) wird nicht abgefangen.
   - Banner der Unteransicht aus <script type="application/json" id="ep-mm-banners"> (sections/ep-desktop-megamenu.liquid);
     <img> wird erst beim Öffnen der Unteransicht erzeugt (je Ansicht einmal).
   - „Zuletzt angesehen“ aus localStorage ep_recently_viewed (assets/ep-recently-viewed.js), max. 6, erst beim
     Öffnen des Drawers; fehlender Preis → /products/<handle>.js (wie v2).
   - Drawer schließen/öffnen → Startansicht + Tab Kategorien. Öffnen/Schließen selbst bleibt beim Theme.
   - Bilder: <img data-epm3-lazy="tile|card" data-src data-srcset> ohne src. Kachelbilder beim ERSTEN Öffnen des Drawers,
     Karten- und Zeilenbilder (data-epm3-lazy="row") einer Unteransicht beim Öffnen dieser Unteransicht, „Zuletzt angesehen“ beim Rendern (nach Öffnen).
     Jedes Bild nur einmal, keine Preloads → 0 Bytes beim Seitenaufruf.
   ========================================================================= */
(function () {
  'use strict';

  var DUR = 250;
  var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function dur() { return reduceMq && reduceMq.matches ? 0 : DUR; }

  /* ---------- Banner ---------- */
  var bannerData = null;
  function getBanners() {
    if (bannerData) return bannerData;
    var el = document.getElementById('ep-mm-banners');
    var list = [];
    if (el) {
      try { list = JSON.parse(el.textContent || '[]') || []; } catch (err) { list = []; }
    }
    bannerData = {};
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (b && b.k && !bannerData[b.k]) bannerData[b.k] = b; /* wie Desktop: erster passender Block */
    }
    return bannerData;
  }

  function ensureBanner(sub) {
    if (!sub || sub.dataset.epm3Bn) return;
    sub.dataset.epm3Bn = '1';
    var slot = sub.querySelector('[data-epm3-bn]');
    var key = sub.getAttribute('data-epm3-key');
    var b = key ? getBanners()[key] : null;
    if (!slot || !b || !b.src) return;
    var cta = sub.querySelector('.epm3-cta');

    var a = document.createElement('a');
    a.className = 'epm3-bn';
    a.href = b.url || (cta ? cta.getAttribute('href') : '#');

    var img = document.createElement('img');
    img.className = 'epm3-bn__img';
    img.width = b.w || 360;
    img.height = b.h || 110;
    img.alt = b.heading || '';
    img.decoding = 'async';
    img.sizes = '(max-width: 480px) 92vw, 360px';
    img.srcset = b.src + ' 360w, ' + (b.src2 || b.src) + ' 540w';
    img.src = b.src;
    a.appendChild(img);

    if (b.heading || b.text) {
      var body = document.createElement('span');
      body.className = 'epm3-bn__body';
      if (b.heading) {
        var t = document.createElement('span');
        t.className = 'epm3-bn__title';
        t.textContent = b.heading;
        body.appendChild(t);
      }
      if (b.text) {
        var p = document.createElement('span');
        p.className = 'epm3-bn__text';
        p.textContent = b.text;
        body.appendChild(p);
      }
      a.appendChild(body);
    }
    slot.appendChild(a);
  }

  /* ---------- Bilder erst bei Bedarf ---------- */
  function loadImgs(scope, kind) {
    if (!scope) return;
    var imgs = scope.querySelectorAll('img[data-epm3-lazy="' + kind + '"]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute('data-epm3-done')) continue;
      img.setAttribute('data-epm3-done', '1');
      var ss = img.getAttribute('data-srcset');
      if (ss) img.srcset = ss;
      var src = img.getAttribute('data-src');
      if (src) img.src = src;
    }
  }

  /* Shopify-CDN-Bild auf Breite w umschreiben; nur http(s)-URLs */
  function cdnImg(u, w) {
    if (u && typeof u === 'object') u = u.url || u.contentUrl || u.src || '';
    if (typeof u !== 'string') return '';
    u = u.trim();
    if (u.indexOf('//') === 0) u = 'https:' + u;
    if (!/^https?:\/\/[^\/]+\//.test(u)) return '';
    try {
      var x = new URL(u);
      if (/(^|\.)cdn\.shopify\.com$/.test(x.hostname) || x.pathname.indexOf('/cdn/shop/') === 0) {
        x.searchParams.set('width', String(w));
        return x.toString();
      }
      return u;
    } catch (err) { return ''; }
  }

  /* ---------- Zuletzt angesehen ---------- */
  var recentDone = false;
  function handleFromUrl(url) {
    var m = /\/products\/([^\/?#]+)/.exec(url || '');
    return m ? m[1] : '';
  }
  function loadRecent(root) {
    if (recentDone) return;
    recentDone = true;
    var box = root.querySelector('[data-epm3-recent]');
    var ul = box && box.querySelector('[data-epm3-recent-list]');
    if (!ul) return;
    var items = [];
    try {
      var raw = window.localStorage.getItem('ep_recently_viewed');
      items = raw ? JSON.parse(raw) : [];
    } catch (err) { items = []; }
    if (!Array.isArray(items)) return;
    var cur = window.location.pathname;
    items = items.filter(function (it) {
      return it && typeof it.title === 'string' && it.title && typeof it.url === 'string' &&
             handleFromUrl(it.url) && it.url !== cur;
    }).slice(0, 6);
    if (!items.length) return;
    var jobs = items.map(function (it) {
      it.img = cdnImg(it.image, 128);
      if ((it.price && it.img) || !window.fetch) return Promise.resolve(it);
      return fetch('/products/' + handleFromUrl(it.url) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (d && !it.img && d.featured_image) it.img = cdnImg(d.featured_image, 128);
          if (d && d.price != null && !it.price) it.price = (d.price_varies ? 'ab ' : '') + (d.price / 100).toFixed(2).replace('.', ',') + ' €';
          if (d && d.vendor && !it.vendor) it.vendor = d.vendor;
          return it;
        })
        .catch(function () { return it; });
    });
    Promise.all(jobs).then(function (list) {
      ul.textContent = '';
      list.forEach(function (it) {
        var li = document.createElement('li');
        li.className = 'epm3-card';
        var a = document.createElement('a');
        a.className = 'epm3-card__a';
        a.href = it.url;
        if (it.img) {
          var im = document.createElement('img');
          im.className = 'epm3-card__img';
          im.width = 64;
          im.height = 64;
          im.alt = '';
          im.decoding = 'async';
          var im2 = cdnImg(it.img, 256);
          if (im2 && im2 !== it.img) im.srcset = it.img + ' 1x, ' + im2 + ' 2x';
          im.src = it.img;
          a.appendChild(im);
        } else {
          var ph = document.createElement('span');
          ph.className = 'epm3-card__img--ph';
          ph.setAttribute('aria-hidden', 'true');
          a.appendChild(ph);
        }
        if (it.vendor) {
          var v = document.createElement('span');
          v.className = 'epm3-card__b';
          v.textContent = it.vendor;
          a.appendChild(v);
        }
        var t = document.createElement('span');
        t.className = 'epm3-card__t';
        t.textContent = it.title;
        a.appendChild(t);
        if (it.price) {
          var pr = document.createElement('span');
          pr.className = 'epm3-card__p';
          pr.textContent = it.price;
          a.appendChild(pr);
        }
        li.appendChild(a);
        ul.appendChild(li);
      });
      box.hidden = false;
    }, function () {});
  }

  /* ---------- Tabs ---------- */
  function selectTab(root, name, focus) {
    var tabs = root.querySelectorAll('[data-epm3-tab]');
    for (var i = 0; i < tabs.length; i++) {
      var tab = tabs[i];
      var on = tab.getAttribute('data-epm3-tab') === name;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.setAttribute('tabindex', on ? '0' : '-1');
      var panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
      if (on && focus) tab.focus();
    }
  }

  /* ---------- Ansichten ---------- */
  var timer = null;
  var lastTile = null;

  function scrollTop(root) {
    var body = root.closest('.sidebar__body');
    if (body) body.scrollTop = 0;
  }

  function openSub(root, tile) {
    var sub = document.getElementById(tile.getAttribute('aria-controls'));
    var main = root.querySelector('[data-epm3-main]');
    if (!sub || !main) return;
    clearTimeout(timer);
    lastTile = tile;
    tile.setAttribute('aria-expanded', 'true');
    sub.hidden = false;
    void sub.offsetWidth; /* Startposition rechts übernehmen, dann animieren */
    root.classList.add('is-sub');
    sub.classList.add('is-active');
    ensureBanner(sub);
    loadImgs(sub, 'card');
    loadImgs(sub, 'row'); /* Zeilenbilder nur dieser Unteransicht */
    scrollTop(root);
    var back = sub.querySelector('[data-epm3-back]');
    if (back) {
      try { back.focus({ preventScroll: true }); } catch (err) { back.focus(); }
    }
    timer = setTimeout(function () {
      main.hidden = true;
      scrollTop(root);
    }, dur());
    if (!dur()) { main.hidden = true; scrollTop(root); }
  }

  function closeSub(root, restoreFocus) {
    var main = root.querySelector('[data-epm3-main]');
    var sub = root.querySelector('[data-epm3-sub].is-active');
    if (!main || !sub) return;
    clearTimeout(timer);
    main.hidden = false;
    void main.offsetWidth;
    root.classList.remove('is-sub');
    sub.classList.remove('is-active');
    scrollTop(root);
    var tile = lastTile;
    if (tile) tile.setAttribute('aria-expanded', 'false');
    if (restoreFocus && tile) {
      try { tile.focus({ preventScroll: false }); } catch (err) { tile.focus(); }
    }
    var hideSub = function () { if (!sub.classList.contains('is-active')) sub.hidden = true; };
    if (dur()) { timer = setTimeout(hideSub, dur()); } else { hideSub(); }
  }

  /* sofort (ohne Animation) zur Startansicht + Tab Kategorien */
  function resetAll(root) {
    clearTimeout(timer);
    root.classList.add('no-anim');
    var subs = root.querySelectorAll('[data-epm3-sub]');
    for (var i = 0; i < subs.length; i++) {
      subs[i].classList.remove('is-active');
      subs[i].hidden = true;
    }
    var tiles = root.querySelectorAll('[data-epm3-open]');
    for (var j = 0; j < tiles.length; j++) tiles[j].setAttribute('aria-expanded', 'false');
    var main = root.querySelector('[data-epm3-main]');
    if (main) main.hidden = false;
    root.classList.remove('is-sub');
    selectTab(root, 'kat', false);
    lastTile = null;
    void root.offsetWidth;
    root.classList.remove('no-anim');
  }

  function closeDrawerSoon() {
    var drawer = document.getElementById('site-menu-sidebar');
    var closeBtn = drawer && drawer.querySelector('[data-js-close]');
    if (closeBtn) setTimeout(function () { closeBtn.click(); }, 50);
  }

  function init() {
    var root = document.querySelector('[data-epm3]');
    if (!root || root.dataset.epm3Init) return;
    root.dataset.epm3Init = '1';

    root.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-epm3-open]');
      if (tile && root.contains(tile)) { e.preventDefault(); openSub(root, tile); return; }

      var back = e.target.closest('[data-epm3-back]');
      if (back && root.contains(back)) { e.preventDefault(); closeSub(root, true); return; }

      var tab = e.target.closest('[data-epm3-tab]');
      if (tab && root.contains(tab)) { e.preventDefault(); selectTab(root, tab.getAttribute('data-epm3-tab'), false); return; }

      var go = e.target.closest('[data-epm3-goto]');
      if (go && root.contains(go)) {
        e.preventDefault();
        if (root.classList.contains('is-sub')) resetAll(root);
        selectTab(root, go.getAttribute('data-epm3-goto'), true);
        scrollTop(root);
        return;
      }

      /* Link im Drawer angetippt: Drawer schließen (Seite lädt ohnehin neu) */
      var link = e.target.closest('a[href]');
      if (link) closeDrawerSoon();
    });

    /* Pfeiltasten in der Tab-Leiste */
    var tablist = root.querySelector('[role="tablist"]');
    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (keys.indexOf(e.key) < 0) return;
        var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[data-epm3-tab]'));
        var idx = tabs.indexOf(document.activeElement);
        if (idx < 0) return;
        e.preventDefault();
        var next = idx;
        if (e.key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
        if (e.key === 'ArrowRight') next = (idx + 1) % tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;
        selectTab(root, tabs[next].getAttribute('data-epm3-tab'), true);
      });
    }

    /* Drawer auf/zu beobachten (Theme: Klasse sidebar--opened + style display) */
    var drawerEl = document.getElementById('site-menu-sidebar');
    if (drawerEl && window.MutationObserver) {
      var wasOpen = false;
      new MutationObserver(function () {
        var isOpen = drawerEl.classList.contains('sidebar--opened') ||
                     (drawerEl.style.display !== '' && drawerEl.style.display !== 'none');
        if (isOpen !== wasOpen) resetAll(root);
        document.documentElement.classList.toggle('epm3-drawer-open', isOpen); /* Klaviyo-Teaser ausblenden (CSS) */
        if (isOpen) {
          loadImgs(root.querySelector('[data-epm3-main]'), 'tile');
          loadRecent(root);
        }
        wasOpen = isOpen;
      }).observe(drawerEl, { attributes: true, attributeFilter: ['class', 'style'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
